import { createIdStore } from "@/listings/listing.marks.ts";

/**
 * Listings you never want to see again.
 *
 * The third kind of mark, and the opposite end of the scale from
 * `listing.tracked.ts`: tracking makes a listing easier to find, hiding takes it
 * off the map entirely. Like the other two it lives in this browser only — the
 * API is read-only, so "hide" can only ever mean "stop showing me".
 *
 * Hidden ids are filtered out *before* the filter stack runs, so a hidden
 * listing never appears in any facet count — it is not "over budget", it is
 * gone. The console's "Show hidden" switch is the way back.
 *
 * Between the seen cap and the tracked cap: bigger than a shortlist, but
 * hiding is deliberate one-at-a-time work, so it will never approach the
 * passively-collected seen set.
 */
const store = createIdStore({ key: "radar.hidden.v1", limit: 1000, label: "HiddenIds" });

export const useHiddenListings = store.use;
export const toggleHidden = store.toggle;
export const clearHidden = store.clear;
